module.exports = __webpack_public_path__ + "static/media/doc-chevron.0a910735.svg";